import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Typography } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';

import { ApplicationCycleDataGridRow } from '@/models/Admin/AdminApplicationCycle/AdminApplicationCycle';

import AdminApplicationCycleDataGrid from './AdminApplicationCycleDataGrid';

export interface AccordionWrapperProps {
  index: number;
  title: string;
  rows: ApplicationCycleDataGridRow[];
  canEdit: boolean;
  expanded: string | false;
  handleChange: (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => void;
}

export const AccordionWrapper: React.FC<AccordionWrapperProps> = ({
  index,
  title,
  rows,
  canEdit,
  expanded,
  handleChange,
}: {
  index: number;
  title: string;
  rows: ApplicationCycleDataGridRow[];
  canEdit: boolean;
  expanded: string | false;
  handleChange: (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => void;
}) => {
  return (
    <Accordion
      key={index}
      expanded={expanded === `panel${index}`}
      sx={{
        border: 'none',
        boxShadow: 'none',
      }}
    >
      <AccordionSummary
        expandIcon={
          <Box
            sx={{
              cursor: 'pointer',
              px: 1,
              borderLeft: expanded !== `panel${index}` ? '1px solid' : 'none',
              borderRight: expanded === `panel${index}` ? '1px solid' : 'none',
              borderColor: 'divider',
            }}
          >
            <ExpandMoreIcon
              onClick={(e) => {
                e.stopPropagation();
                handleChange(`panel${index}`)(e, expanded !== `panel${index}`);
              }}
            />
          </Box>
        }
        aria-controls={`panel${index}d-content`}
        id={`panel${index}d-header`}
        onClick={(e) => e.stopPropagation()}
        sx={{ pr: 0, cursor: 'default !important', '&:hover': { cursor: 'default !important' } }}
      >
        <Typography variant='h6'>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <AdminApplicationCycleDataGrid rows={rows} canEdit={canEdit} />
      </AccordionDetails>
    </Accordion>
  );
};
